(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-estimation"] && !Shopify.designMode) return;
  try {
    (function() {
    function injectAllDeliveryProperties() {
      var elements = document.querySelectorAll('.delivery-estimation__text');
      elements.forEach(function(el) {
        var raw = el.textContent.trim();
        var value = raw.replace(/^Livraison\s+estimée\s+/i, '');
        if (!value) return;

        var form = el.closest('form[data-type="add-to-cart-form"]')
          || el.closest('.product-details')?.querySelector('form[data-type="add-to-cart-form"]')
          || el.closest('.product-information')?.querySelector('form[data-type="add-to-cart-form"]')
          || el.closest('#quick-add-modal-content')?.querySelector('form[data-type="add-to-cart-form"]');

        if (form) {
          var existing = form.querySelector('input[name="properties[Livraison estimée]"]');
          if (!existing) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'properties[Livraison estimée]';
            input.value = value;
            form.appendChild(input);
          } else {
            existing.value = value;
          }
        }
      });
    }

    injectAllDeliveryProperties();

    var observer = new MutationObserver(injectAllDeliveryProperties);
    observer.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
